import { DEFAULT_DATE_TIME_RANGE } from '@modules/common/components/DateRangePicker/constants';
import { DateTimeRange } from '@modules/common/components/DateRangePicker/types';
import { getDefaultTimeRangeForTenant } from '@modules/common/utils/getDefaultTimeRangeForTenant';
import { useMemo } from 'react';
import { useGetUser } from 'v2/core/services/user';

export const useGetDefaultTenantTimeRange = () => {
  const {
    tenant: {
      id: tenantID,
      dashboardSettings: { defaultTimeRange },
    },
  } = useGetUser();

  return useMemo((): DateTimeRange => {
    if (!defaultTimeRange) {
      // `useGetUser` has cached data, so logged in users might not get defined `defaultTimeRange`.
      // So, falling back to hardcoded one from `getDefaultTimeRangeForTenant`
      // TODO: We can remove this fallback in a month or so.
      return getDefaultTimeRangeForTenant(tenantID) ?? DEFAULT_DATE_TIME_RANGE;
    }

    return defaultTimeRange;
  }, [defaultTimeRange, tenantID]);
};
